<template>
    <layout-bigscreen nav_top="0">
        <div id="antdVue" ref="antdVue" :style="themeColorInit(themeColorConfig)" class="zoom_bg_color" style="width:100%; height:100%;">
            <div class="antdVue" :style="{...calculateStyles}">

                <div class="flex flex-direction justify-center benben-flex-layout sousuofenxidaping_139_random_flex_0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100">
                    <div class="flex flex-wrap align-center justify-center sousuofenxidaping_132_fd0_0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100 f-c-3 position-relative bg-size-auto">
                        <div class="flex  flex-wrap align-center sousuofenxidaping_205_fd0_0_c0 position-absolute">
                            <img class='sousuofenxidaping_572_fd0_0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/03e56738af5b3ecc593d3c6c58203cc6.png" />
                            <span class="sousuofenxidaping_736_fd0_0_c0_c1 t-20 t-w-4">多云</span>
                            <div class="flex  flex-wrap align-center sousuofenxidaping_174_fd0_0_c0_c2 bg-size-auto">

                            </div>
                            <span class="sousuofenxidaping_653_fd0_0_c0_c3 t-20 h-10-px t-w-4">6</span>
                            <span class="sousuofenxidaping_653_fd0_0_c0_c3 t-20 h-10-px t-w-4">℃</span>

                        </div>
                        <img class='sousuofenxidaping_895_fd0_0_c1' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/e86a55b2a20775c71c1fb6cc91dd3c1e.png" />
                        <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">搜索大屏</span>
                        <img class='sousuofenxidaping_200_fd0_0_c3' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/d3adc8fbbce7c9aa2bbd0f8ae8ac5a40.png" />
                        <div class="flex align-center sousuofenxidaping_820_fd0_0_c4 position-absolute">
                            <img class='sousuofenxidaping_675_fd0_0_c4_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/2af63761ef0068fdbbfded13de1d740c.png" />

                            <benben-real-time class='flex align-center justify-center sousuofenxidaping_257_random_fd0_0_c4_c1 t-18 t-w-4' format="YYYY-MM-DD HH:mm:ss" :has_week="true" :refresh_interval="500" show_title="true" title_position="left" title_name="标题">

                            </benben-real-time>


                        </div>

                        <benben-full-screen class='flex align-center justify-center sousuofenxidaping_529_random_fd0_0_c5 position-absolute a'>

                        </benben-full-screen>


                    </div>

                    <a-row class="benben-grid   w-100" :gutter="[8,8]" type="flex">

                        <a-col :xs="24" :md="6" :xl="6" :xxl="6">
                            <div class="flex  flex-wrap align-center sousuofenxidaping_514_fd0_1_c0_c0 pd-t-0 pd-r-0 pd-b-0 pd-l-10 w-100">
                                <div class="flex flex-direction align-center sousuofenxidaping_787_fd0_1_c0_c0_c0 w-100">
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_167_fd0_1_c0_c0_c0_c0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100 position-relative">
                                        <span class="sousuofenxidaping_597_fd0_1_c0_c0_c0_c0_c0 f-c-fff t-22 t-w-5 position-absolute">搜索用户数柱图</span>

                                    </div>
                                    <div class="flex flex-direction flex-wrap align-center sousuofenxidaping_685_fd0_1_c0_c0_c0_c1 w-100 bg-size-100 position-relative">

                                        <benben-bar-base class='w-100 h-100' :field-options="userSearchAxis" data_source_type="1" chart_show_type="bar-base" show_title="false" title_position="left" title_name="标题" :linear_gradient_color="[{'start':10,'color1':'rgba(255, 199, 46, 1)','color2':'rgba(255, 118, 0, 1)'}]" :theme_color="theme_color_4101" :chart-option="chartOptions_random_2780">

                                        </benben-bar-base>


                                    </div>

                                </div>
                                <div class="flex flex-wrap align-start justify-center sousuofenxidaping_646_fd0_1_c0_c0_c1 w-100">
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_167_fd0_1_c0_c0_c0_c0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100 position-relative">
                                        <span class="sousuofenxidaping_597_fd0_1_c0_c0_c0_c0_c0 f-c-fff t-22 t-w-5 position-absolute">近7天搜索下单量</span>

                                    </div>
                                    <div class="flex flex-direction flex-wrap align-center sousuofenxidaping_685_fd0_1_c0_c0_c0_c1 w-100 bg-size-100 position-relative">

                                        <benben-line-area-accumul class='w-100 h-100' :field-options="field_options_132146" data_source_type="1" chart_show_type="line-area-accumul" show_title="false" title_position="left" title_name="标题" :linear_gradient_color="[{'start':10,'color1':'rgba(13, 251, 226, 0.02)','color2':'rgba(13, 251, 226, 0.48)'}]" :theme_color="theme_color_8968" :chart-option="chartOptions_random_6389">

                                        </benben-line-area-accumul>


                                    </div>

                                </div>
                                <div class="flex flex-wrap align-start justify-center sousuofenxidaping_646_fd0_1_c0_c0_c1 w-100">
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_167_fd0_1_c0_c0_c0_c0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100 position-relative">
                                        <span class="sousuofenxidaping_597_fd0_1_c0_c0_c0_c0_c0 f-c-fff t-22 t-w-5 position-absolute">近7天日搜词</span>

                                    </div>
                                    <div class="flex flex-direction flex-wrap align-center sousuofenxidaping_685_fd0_1_c0_c0_c0_c1 w-100 bg-size-100 position-relative">

                                        <word-cloud :field-options="userSearchWord" data_source_type="1" chart_show_type="word_cloud" type="word" :width="400" :height="300" :radius="120" :font-size="16" :speed="30" width="100%" height="100%" :theme_color="theme_color_4190">

                                        </word-cloud>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                        <a-col :xs="24" :md="12" :xl="12" :xxl="12">
                            <div class="flex flex-direction align-center self-center  w-100 h-100 position-relative">
                                <div class="flex flex-wrap align-center justify-center sousuofenxidaping_802_fd0_1_c1_c0_c0 w-100 bg-size-100">
                                    <img class='sousuofenxidaping_349_fd0_1_c1_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240222/6de23d9ffdcbb1109dcc7d512ae3fdc8.png" />
                                    <span class="sousuofenxidaping_519_fd0_1_c1_c0_c0_c1 f-c-fff t-20">近7天搜索统计</span>
                                    <img class='sousuofenxidaping_349_fd0_1_c1_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240222/cdfda7ee291ed4ae21ece1a45d415f47.png" />

                                </div>
                                <div class="flex flex-direction align-center sousuofenxidaping_753_fd0_1_c1_c0_c1 bg-size-100">
                                    <div class="flex align-center justify-between sousuofenxidaping_307_fd0_1_c1_c0_c1_c0 w-100">
                                        <div class="flex flex-direction flex-wrap align-center self-center justify-center sousuofenxidaping_967_fd0_1_c1_c0_c1_c0_c0 bg-size-100">
                                            <div class="flex flex-direction align-center justify-center sousuofenxidaping_350_fd0_1_c1_c0_c1_c0_c0_c0 w-100">

                                                <benben-light-text class='light-text sousuofenxidaping_174_random_fd0_1_c1_c0_c1_c0_c0_c0_c0 f-c-9' :field-options="orderCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="sousuofenxidaping_291_fd0_1_c1_c0_c1_c0_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-24 t-w-7 f-c-3">次数</span>

                                            </div>

                                        </div>
                                        <div class="flex  flex-wrap align-center sousuofenxidaping_967_fd0_1_c1_c0_c1_c0_c0 bg-size-100">
                                            <div class="flex flex-direction align-center justify-center sousuofenxidaping_350_fd0_1_c1_c0_c1_c0_c0_c0 w-100">

                                                <benben-light-text class='light-text sousuofenxidaping_174_random_fd0_1_c1_c0_c1_c0_c0_c0_c0 f-c-9' :field-options="orderUserCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="sousuofenxidaping_291_fd0_1_c1_c0_c1_c0_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-24 t-w-7 f-c-3">搜索用户数</span>

                                            </div>

                                        </div>

                                    </div>
                                    <div class="flex align-center justify-between sousuofenxidaping_307_fd0_1_c1_c0_c1_c1 mg-t-30 mg-r-0 mg-b-0 mg-l-0 w-100">
                                        <div class="flex flex-direction flex-wrap align-center self-center justify-center sousuofenxidaping_967_fd0_1_c1_c0_c1_c0_c0 bg-size-100">
                                            <div class="flex flex-direction align-center justify-center sousuofenxidaping_350_fd0_1_c1_c0_c1_c0_c0_c0 w-100">

                                                <benben-light-text class='light-text sousuofenxidaping_993_random_fd0_1_c1_c0_c1_c1_c0_c0_c0 f-c-9' :field-options="keywordCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="sousuofenxidaping_291_fd0_1_c1_c0_c1_c0_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-24 t-w-7 f-c-3">关键词数</span>

                                            </div>

                                        </div>
                                        <div class="flex  flex-wrap align-center sousuofenxidaping_967_fd0_1_c1_c0_c1_c0_c0 bg-size-100">
                                            <div class="flex flex-direction align-center justify-center sousuofenxidaping_350_fd0_1_c1_c0_c1_c0_c0_c0 w-100">

                                                <benben-light-text class='light-text sousuofenxidaping_899_random_fd0_1_c1_c0_c1_c1_c1_c0_c0 f-c-9' :field-options="avgSearchCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>

                                                <span class="sousuofenxidaping_291_fd0_1_c1_c0_c1_c0_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 t-24 t-w-7 f-c-3">人均搜索量</span>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                                <div class="flex flex-direction align-center justify-center sousuofenxidaping_702_fd0_1_c1_c0_c2 w-100">
                                    <div class="flex flex-wrap align-center justify-center sousuofenxidaping_800_fd0_1_c1_c0_c2_c0 w-100 bg-size-100">
                                        <img class='sousuofenxidaping_349_fd0_1_c1_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240222/6de23d9ffdcbb1109dcc7d512ae3fdc8.png" />
                                        <span class="sousuofenxidaping_519_fd0_1_c1_c0_c0_c1 f-c-fff t-20">近7天搜索曲线</span>
                                        <img class='sousuofenxidaping_349_fd0_1_c1_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240222/cdfda7ee291ed4ae21ece1a45d415f47.png" />

                                    </div>
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_486_fd0_1_c1_c0_c2_c1 w-100">
                                        <div class="flex  flex-wrap align-center sousuofenxidaping_581_fd0_1_c1_c0_c2_c1_c0 w-100 h-100 bg-size-100 position-relative">
                                            <img class='sousuofenxidaping_793_fd0_1_c1_c0_c2_c1_c0_c0 position-absolute' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240221/ad336e980e5c67773f9885d6f1db95b1.png" />

                                            <benben-line-simple class='sousuofenxidaping_548_random_fd0_1_c1_c0_c2_c1_c0_c1 w-100' :field-options="userSearchLine" data_source_type="1" chart_show_type="line-simple" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_3117" :chart-option="chartOptions_random_6446">

                                            </benben-line-simple>


                                        </div>

                                    </div>

                                </div>

                            </div>

                        </a-col>


                        <a-col :xs="24" :md="6" :xl="6" :xxl="6">
                            <div class="flex  flex-wrap align-center sousuofenxidaping_514_fd0_1_c0_c0 w-100">
                                <div class="flex flex-direction align-center sousuofenxidaping_787_fd0_1_c0_c0_c0 w-100">
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_167_fd0_1_c0_c0_c0_c0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100 position-relative">
                                        <span class="sousuofenxidaping_597_fd0_1_c0_c0_c0_c0_c0 f-c-fff t-22 t-w-5 position-absolute">近7天搜索方式分布</span>

                                    </div>
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_527_fd0_1_c2_c0_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 w-100 h-100 bg-size-100">
                                        <div class="flex  flex-wrap align-center sousuofenxidaping_302_fd0_1_c2_c0_c0_c1_c0 w-100 h-100 position-relative">
                                            <img class='sousuofenxidaping_582_fd0_1_c2_c0_c0_c1_c0_c0 w-40-px h-40-px position-absolute' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240227/fb115be7093ec3eeedc850ae6f17b816.png" />

                                            <benben-pie-ring class='w-100 h-100' :field-options="userSearchType" data_source_type="1" chart_show_type="pie-ring" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_5758" :chart-option="chartOptions_random_2565">

                                            </benben-pie-ring>


                                        </div>

                                    </div>

                                </div>
                                <div class="flex flex-wrap align-start justify-center sousuofenxidaping_646_fd0_1_c0_c0_c1 w-100">
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_167_fd0_1_c0_c0_c0_c0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100 position-relative">
                                        <span class="sousuofenxidaping_597_fd0_1_c0_c0_c0_c0_c0 f-c-fff t-22 t-w-5 position-absolute">近7天使用终端分布</span>

                                    </div>
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_956_fd0_1_c2_c0_c1_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 w-100 bg-size-100">
                                        <div class="flex  flex-wrap align-center sousuofenxidaping_302_fd0_1_c2_c0_c0_c1_c0 w-100 h-100 position-relative">
                                            <img class='sousuofenxidaping_582_fd0_1_c2_c0_c0_c1_c0_c0 w-40-px h-40-px position-absolute' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240227/fb115be7093ec3eeedc850ae6f17b816.png" />

                                            <benben-pie-ring class='w-100 h-100' :field-options="userSourcePie" data_source_type="1" chart_show_type="pie-ring" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_5836" :chart-option="chartOptions_random_1699">

                                            </benben-pie-ring>


                                        </div>

                                    </div>

                                </div>
                                <div class="flex flex-wrap align-start justify-center sousuofenxidaping_646_fd0_1_c0_c0_c1 w-100">
                                    <div class="flex  flex-wrap align-center sousuofenxidaping_167_fd0_1_c0_c0_c0_c0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100 position-relative">
                                        <span class="sousuofenxidaping_597_fd0_1_c0_c0_c0_c0_c0 f-c-fff t-22 t-w-5 position-absolute">近7天搜索用户排行</span>

                                    </div>
                                    <div class="flex flex-direction flex-wrap align-center sousuofenxidaping_685_fd0_1_c0_c0_c0_c1 w-100 bg-size-100 position-relative">

                                        <benben-bar-cross class='sousuofenxidaping_548_random_fd0_1_c1_c0_c2_c1_c0_c1 w-100' :field-options="userSearchRank" data_source_type="1" chart_show_type="bar-cross" show_title="false" title_position="left" title_name="标题" :is_morcolor="false" :theme_color="theme_color_7641" :chart-option="chartOptions_random_6071">

                                        </benben-bar-cross>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                    </a-row>


                </div>

            </div>
        </div>
    </layout-bigscreen>
</template>
<script>
    import {
        bigScreenMixins,
        receiveNew
    } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
    import {
        receive,
        benbenSelectDiy,
        benbenFlexNumberBox,
        scrollList,
        treeSelect,
        simpleSelect,
        multipleSelect,
        cascaderForm,
        checkboxForm,
        switchForm,
        messageReply,
        rangePicker,
        handSignature,
        mixinAddTableItem,
        editorForm,
        qiunDataCharts,
        copyText,
        mixinTableItemChange,
        in_array,
        themeColorInit,
        getUrlKey,
        clearDataPass,
        isEmpty,
        treeEdit
    } from '@/assets/diypaaspc/diy-pass-pc.js'
    import {
        provinceForm
    } from '@/assets/diypaaspc/province_area.js'
    import request from '@/utils/request'
    import * as echarts from 'echarts'
    import 'echarts-gl'
    import 'echarts-liquidfill'
    import {
        mapdata
    } from '@/assets/diypaaspc/mapdata.js'
    import layoutBigscreen from "@/components/layoutBigscreen"
    import {userSearchAxis, userSearchRank, userSearchType, userSearchWord, userSource} from "@/api/statistics/user";
    import moment from 'moment';

    export default {
        name: 'sousuofenxidaping',
        components: {
            layoutBigscreen
        },
        mixins: [bigScreenMixins],
        data() {
            const themeColorConfig = {
                "presetApi": {
                    "getClassifyOne": "",
                    "getClassifyTow": "",
                    "getClassifyShop": ""
                },
                "themeType": 0,
                "themeConfig": [{
                    "colorConfig": ["#333333", "#666666", "#999999", "#ffffff", "#0052c7", "#F02325", "#FC9C3A", "#4DC777", "#F2CC98", "#F2CC66"],
                    "bgColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#FC9fff", "#E6F333", "#E6F1FE", "linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)", "linear-gradient(180deg, #F5588E 0%, #F0403C 100%)", "linear-gradient(179deg, #FFD033 0%, #F4890E 100%)"],
                    "bdColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#333333", "#666666", "#999999", "#dddddd", "#1178F0", "#F02325"]
                }]
            };
            receive(this);
            receiveNew(this);
            return {
                themeColorConfig,
                mapdata: mapdata,
                "isFullScreen": false,
                "big_screen_global_query": {
                    "screen_global_time_range_type": "5",
                    "screen_global_time_custom_time": "",
                    "screen_global_dept": "",
                    "screen_global_user": "",
                    "diy_api_time": ""
                },
                "saizhuge_api_loaded": false,
                "school_info": {},
                "weather_info": {},
                "weather_data": [{
                    "name": "晴",
                    "code": "0",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
                }, {
                    "name": "夜晚晴",
                    "code": "1",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
                }, {
                    "name": "晴",
                    "code": "2",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
                }, {
                    "name": "夜晚晴",
                    "code": "3",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
                }, {
                    "name": "多云",
                    "code": "4",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/937ea42d4d54677a960419fc926d2308.png"
                }, {
                    "name": "晴间多云",
                    "code": "5",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
                }, {
                    "name": "晴间多云",
                    "code": "6",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
                }, {
                    "name": "大部多云",
                    "code": "7",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8c1710ce88d626dad374865cc5cc285d.png"
                }, {
                    "name": "大部多云",
                    "code": "8",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8e47c4a733b6ea39aa94ea362bc942fa.png"
                }, {
                    "name": "阴",
                    "code": "9",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/b8a945d068a4c968e5c05e023a67571f.png"
                }, {
                    "name": "阵雨",
                    "code": "10",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2987ff71ec8f90fdffa1c0114e13b1f9.png"
                }, {
                    "name": "雷阵雨",
                    "code": "11",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/751a274ee37d368cd45471edc5b35411.png"
                }, {
                    "name": "雷阵雨伴有冰雹",
                    "code": "12",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/2c7657970388a04e29049a23a0046c56.png"
                }, {
                    "name": "小雨",
                    "code": "13",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/6b02916ef905c0f100e3e6d4bf4c4ff0.png"
                }, {
                    "name": "中雨",
                    "code": "14",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/cc26fd0d1cda78eda4b53d85718b8803.png"
                }, {
                    "name": "大雨",
                    "code": "15",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/1598c140199a349d9ec4aed4482f0cf1.png"
                }, {
                    "name": "暴雨",
                    "code": "16",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
                }, {
                    "name": "大暴雨",
                    "code": "17",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b460fe42bb0e8dcbc177b5d6ef5b3c30.png"
                }, {
                    "name": "特大暴雨",
                    "code": "18",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
                }, {
                    "name": "冻雨",
                    "code": "19",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/121096065da289cc9ebf23c778c8a4e8.png"
                }, {
                    "name": "雨夹雪",
                    "code": "20",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d9c47f9707616842680ba38e1c8e4d43.png"
                }, {
                    "name": "阵雪",
                    "code": "21",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/af6e554f62f546c76b3b495df7f36eb2.png"
                }, {
                    "name": "小雪",
                    "code": "22",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/71744d3bd3230b10f5d09666a76657ea.png"
                }, {
                    "name": "中雪",
                    "code": "23",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a29d1ac31de2a2cdaecfb4c579cdf928.png"
                }, {
                    "name": "大雪",
                    "code": "24",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/62145c7aea6a3e65c5f1dc8d84f5c92d.png"
                }, {
                    "name": "暴雪",
                    "code": "25",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/50946c87ed7c0e4c471d7cb0310115c3.png"
                }, {
                    "name": "浮尘",
                    "code": "26",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/46258a78adc3acf03d0186836e89b798.png"
                }, {
                    "name": "扬沙",
                    "code": "27",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a2440c63509d48eb1fa45804c6476f7d.png"
                }, {
                    "name": "沙尘暴",
                    "code": "28",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/9a80471d8001ea814aa4206d3feda602.png"
                }, {
                    "name": "强沙尘暴",
                    "code": "29",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/da4066fc0584850d72ec402894765b2d.png"
                }, {
                    "name": "雾",
                    "code": "30",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/4cf7128b075acfd65af6ea175f7240ce.png"
                }, {
                    "name": "霾",
                    "code": "31",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/c6325f4ef718e9aef9dbff86e2d28817.png"
                }, {
                    "name": "风",
                    "code": "32",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/dccb4227577c4f0e51c6b9b16fa75af1.png"
                }, {
                    "name": "大风",
                    "code": "33",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b1d9445881a4a9d0b1471f831d3800c8.png"
                }, {
                    "name": "飓风",
                    "code": "34",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d58120ad96b2b4df9f4ffb35dc07c3c7.png"
                }, {
                    "name": "热带风暴",
                    "code": "35",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/3ca919f2ae75739b3196460dfffdd405.png"
                }, {
                    "name": "龙卷风",
                    "code": "36",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
                }, {
                    "name": "冷",
                    "code": "37",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
                }, {
                    "name": "热",
                    "code": "38",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d33c81b9f8772998d9bba7d3ea52acb0.png"
                }, {
                    "name": "未知",
                    "code": "99",
                    "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/db353a99b557f85968a262210c69f0d7.png"
                }],
                "viewSource": "PC",
                "big_screen_global_config": {
                    "is_screen_global_time": false,
                    "is_screen_global_dept": false,
                    "is_screen_global_user": false
                },
                "designWidth": 1920,
                "designHeight": 1080,
                "calculateStyles": {},
                "screenWidth": window.innerWidth,
                "screenHeight": window.innerHeight,
                "timerW": false,
                "timerH": false,
                "page_scale": 1,
                "theme_color_7641": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                "chartOptions_random_6071": {
                    "tooltip": {
                        "show": true,
                        "trigger": "axis",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "inherit",
                            "fontSize": 14
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "textStyle": {
                            "color": "#fff"
                        },
                        "show": false,
                        "orient": "horizontal",
                        "left": "center",
                        "top": ""
                    },
                    "grid": {
                        "left": "3%",
                        "right": "6%",
                        "bottom": "3%",
                        "top": "6%",
                        "containLabel": true
                    },
                    "barSetting": {
                        "barWidth": 16,
                        "markPoint": {
                            "label": {
                                "normal": {
                                    "textStyle": {
                                        "color": "#fff",
                                        "fontSize": 14,
                                        "fontWeight": 400
                                    }
                                }
                            },
                            "itemStyle": [],
                            "data": [],
                            "symbol": "pin",
                            "symbolSize": 50
                        },
                        "label": {
                            "normal": {
                                "show": true,
                                "position": "right",
                                "fontSize": 16,
                                "color": "#fff"
                            }
                        },
                        "itemStyle": {
                            "borderRadius": [5, 5, 5, 5]
                        },
                        "markLine": {
                            "label": {
                                "color": "#fff"
                            },
                            "symbol": "none",
                            "lineStyle": {
                                "type": "dashed"
                            },
                            "data": []
                        }
                    },
                    "xAxis": {
                        "type": "value",
                        "axisTick": {
                            "show": true
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400,
                            "rotate": 0
                        },
                        "splitLine": {
                            "show": false,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "yAxis": {
                        "type": "category",
                        "axisTick": {
                            "show": false
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400
                        },
                        "splitLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    }
                },
                userSearchRank: {
                    "yAxis": {
                        "data": ["用户名1", "用户名2", "用户名3"]
                    },
                    "series": [{
                        "name": "记录数量",
                        "type": "bar",
                        "data": [1, 2, 3]
                    }]
                },
                "theme_color_5836": ["#0DFBE2", "#FBF800", "#FF8C19", "#8B36FF", "#FF8C19"],
                "chartOptions_random_1699": {
                    "seriesSetting": {
                        "center": ["30%", "50%"],
                        "radius": ["57%", "77%"],
                        "itemStyle": {
                            "borderColor": "",
                            "borderWidth": "",
                            "borderRadius": ""
                        },
                        "startAngle": "",
                        "type": "pie",
                        "label": {
                            "color": "#fff"
                        }
                    },
                    "labelSetting": {
                        "label": {
                            "color": "#fff",
                            "show": false,
                            "emphasis": {
                                "show": false,
                                "textStyle": {
                                    "fontSize": 14,
                                    "color": "#fff"
                                },
                                "rich": {
                                    "a": {
                                        "fontSize": 14
                                    }
                                }
                            }
                        },
                        "labelLine": {
                            "show": true
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "icon": "circle",
                        "itemGap": 20,
                        "textStyle": {
                            "color": "#fff",
                            "fontSize": 16
                        },
                        "show": true,
                        "orient": "vertical",
                        "left": "63%",
                        "top": "middle"
                    },
                    "tooltip": {
                        "show": true,
                        "autoToolTip": true,
                        "trigger": "item",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "rgba(255, 255, 255, 1)",
                            "fontSize": 15
                        },
                        "backgroundColor": "rgba(0, 0, 0, 0.8)",
                        "borderColor": "rgba(255, 255, 255, 0)"
                    }
                },
                userSourcePie: {
                    "series": [{
                        "data": [{
                            "value": 1335,
                            "name": "安卓APP"
                        }, {
                            "value": 810,
                            "name": "IOSAPP"
                        }]
                    }]
                }, // 近7天使用终端分布
                "theme_color_5758": ["#FF8C19", "#8B36FF", "#0DFBE2", "#FBF800", "#FF8C19"],
                "chartOptions_random_2565": {
                    "seriesSetting": {
                        "center": ["30%", "50%"],
                        "radius": ["57%", "77%"],
                        "itemStyle": {
                            "borderColor": "",
                            "borderWidth": "",
                            "borderRadius": ""
                        },
                        "startAngle": "",
                        "type": "pie",
                        "label": {
                            "color": "#fff"
                        }
                    },
                    "labelSetting": {
                        "label": {
                            "color": "#fff",
                            "show": false,
                            "emphasis": {
                                "show": false,
                                "textStyle": {
                                    "fontSize": 14,
                                    "color": "#fff"
                                },
                                "rich": {
                                    "a": {
                                        "fontSize": 14
                                    }
                                }
                            }
                        },
                        "labelLine": {
                            "show": true
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "icon": "circle",
                        "itemGap": 20,
                        "textStyle": {
                            "color": "#fff",
                            "fontSize": 16
                        },
                        "show": true,
                        "orient": "vertical",
                        "left": "63%",
                        "top": "middle"
                    },
                    "tooltip": {
                        "show": true,
                        "autoToolTip": true,
                        "trigger": "item",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "rgba(255, 255, 255, 1)",
                            "fontSize": 15
                        },
                        "backgroundColor": "rgba(0, 0, 0, 0.8)",
                        "borderColor": "rgba(255, 255, 255, 0)"
                    }
                },
                userSearchType: {
                    "series": [{
                        "data": [{
                            "value": 1335,
                            "name": "搜索发现"
                        }, {
                            "value": 810,
                            "name": "建议词搜索"
                        }]
                    }]
                }, // 近7天搜索方式分布
                "theme_color_3117": ["#6AE7E6", "#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#0F36A2", "#FC658A"],
                "chartOptions_random_6446": {
                    "tooltip": {
                        "trigger": "axis",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "inherit",
                            "fontSize": 14
                        }
                    },
                    "legend": {
                        "type": "scroll",
                        "textStyle": {
                            "color": "#fff"
                        },
                        "show": true,
                        "orient": "horizontal",
                        "left": "center",
                        "top": ""
                    },
                    "grid": {
                        "left": "1%",
                        "right": "2%",
                        "bottom": "0%",
                        "top": "15%",
                        "containLabel": true
                    },
                    "xAxis": {
                        "type": "category",
                        "axisTick": {
                            "show": true
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400,
                            "rotate": 0
                        },
                        "splitLine": {
                            "show": false,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "yAxis": {
                        "type": "value",
                        "axisTick": {
                            "show": false
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 12,
                            "fontWeight": 400
                        },
                        "splitLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(255, 255, 255, 0.2)"
                            }
                        }
                    },
                    "seriesSetting": {
                        "markPoint": {
                            "label": {
                                "normal": {
                                    "textStyle": {
                                        "color": "#fff",
                                        "fontSize": 14,
                                        "fontWeight": 400
                                    }
                                }
                            },
                            "itemStyle": [],
                            "data": [],
                            "symbol": "pin",
                            "symbolSize": 50
                        },
                        "markLine": {
                            "data": [],
                            "lineStyle": {
                                "type": "dashed"
                            },
                            "label": {
                                "color": "#fff"
                            },
                            "symbol": "none"
                        },
                        "label": {
                            "normal": {
                                "show": false,
                                "position": "top",
                                "fontSize": 14,
                                "color": "inherit"
                            }
                        }
                    }
                },
                userSearchLine: {
                    "xAxis": {
                        "data": ["2026-01-19", "2026-01-20", "2026-01-21", "2026-01-22", "2026-01-23", "2026-01-24", "2026-01-25", "2026-01-26", "2026-01-27"]
                    },
                    "series": [{
                        "name": "记录数量",
                        "data": [19, 57, 46, 80, 27, 69, 86, 85, 80],
                        "type": "line"
                    }]
                },
                avgSearchCount: {
                    "data": 27
                }, // 人均搜索量
                keywordCount: {
                    "data": 21
                }, // 关键词数
                orderUserCount: {
                    "data": 55
                }, // 搜索用户数
                orderCount: {
                    "data": 45
                }, // 次数
                "theme_color_4190": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                userSearchWord: {
                    "series": [{
                        "name": "跨全端图表",
                        "value": 1.2,
                    }, {
                        "name": "微信小程序",
                        "value": 1
                    }, {
                        "name": "支付宝小程序",
                        "value": 1.2
                    }, {
                        "name": "百度小程序",
                        "value": 1
                    }, {
                        "name": "QQ小程序",
                        "value": 1.5
                    }, {
                        "name": "头条小程序",
                        "value": 1.5
                    }, {
                        "name": "抖音小程序",
                        "value": 1
                    }, {
                        "name": "360小程序",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }, {
                        "name": "跨全端",
                        "value": 1
                    }]
                }, // 近7天日搜词
                "theme_color_8968": ["#0DFBE2", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                "chartOptions_random_6389": {
                    "tooltip": {
                        "show": true,
                        "trigger": "axis",
                        "axisPointer": {
                            "type": "line",
                            "lineStyle": {
                                "color": "#6E7079"
                            }
                        },
                        "textStyle": {
                            "color": "rgba(255, 255, 255, 1)",
                            "fontSize": 15
                        },
                        "autoToolTip": true,
                        "backgroundColor": "rgba(0, 0, 0, 0.8)",
                        "borderColor": "rgba(255, 0, 0, 0)"
                    },
                    "legend": {
                        "type": "scroll",
                        "textStyle": {
                            "color": "#fff"
                        },
                        "show": false,
                        "orient": "horizontal",
                        "left": "center",
                        "top": ""
                    },
                    "grid": {
                        "left": "3%",
                        "right": "5%",
                        "bottom": "5%",
                        "top": "10%",
                        "containLabel": true
                    },
                    "yAxis": {
                        "type": "value",
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "#6E7079"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 14,
                            "fontWeight": 400
                        },
                        "splitLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(97, 122, 190, 0.2)",
                                "type": "dashed"
                            }
                        }
                    },
                    "xAxis": {
                        "type": "category",
                        "axisTick": {
                            "show": false
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "#6E7079"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 14,
                            "fontWeight": 500,
                            "rotate": 0
                        },
                        "splitLine": {
                            "show": false,
                            "lineStyle": {
                                "color": "#6E7079"
                            }
                        }
                    },
                    "seriesSetting": {
                        "areaStyle": {
                            "show": true
                        },
                        "markPoint": {
                            "label": {
                                "normal": {
                                    "textStyle": {
                                        "color": "#fff",
                                        "fontSize": 14,
                                        "fontWeight": 400
                                    }
                                }
                            },
                            "itemStyle": [],
                            "data": [],
                            "symbol": "pin",
                            "symbolSize": 50
                        },
                        "markLine": {
                            "data": [],
                            "lineStyle": {
                                "type": "dashed",
                                "color": "rgba(13, 251, 226, 1)"
                            },
                            "label": {
                                "color": "rgba(255, 255, 255, 0)"
                            },
                            "symbol": "none"
                        },
                        "label": {
                            "normal": {
                                "show": true,
                                "position": "top",
                                "fontSize": 12,
                                "color": "rgba(13, 251, 226, 1)",
                                "fontWeight": 500
                            }
                        }
                    }
                },
                "field_options_132146": {
                    "xAxis": {
                        "data": ["2025-01-19", "2025-01-20", "2025-01-21", "2025-01-22"] // 日期
                    },
                    "series": [{
                        "name": "记录数量",
                        "smooth": true,
                        "data": [320, 340, 159, 376], // 数量 跟日期数量一致
                        "type": "line",
                        "areaStyle": []
                    }]
                }, // 近7天搜索下单量
                "theme_color_4101": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
                "chartOptions_random_2780": {
                    "tooltip": {
                        "show": true,
                        "autoToolTip": true,
                        "trigger": "axis",
                        "axisPointer": {
                            "type": "shadow"
                        },
                        "textStyle": {
                            "color": "rgba(255, 255, 255, 1)",
                            "fontSize": 15
                        },
                        "backgroundColor": "rgba(0, 0, 0, 0.8)",
                        "borderColor": "rgba(255, 255, 255, 0)"
                    },
                    "legend": {
                        "type": "scroll",
                        "textStyle": {
                            "color": "#fff"
                        },
                        "show": false,
                        "orient": "horizontal",
                        "left": "center",
                        "top": ""
                    },
                    "grid": {
                        "left": "3%",
                        "right": "5%",
                        "bottom": "5%",
                        "top": "15%",
                        "containLabel": true
                    },
                    "xAxis": {
                        "type": "category",
                        "axisTick": {
                            "show": false
                        },
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(57, 82, 150, 1)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 14,
                            "fontWeight": 400,
                            "rotate": 0
                        },
                        "splitLine": {
                            "show": false,
                            "lineStyle": {
                                "color": "#6E7079"
                            }
                        }
                    },
                    "yAxis": {
                        "type": "value",
                        "axisLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(57, 82, 150, 1)"
                            }
                        },
                        "axisLabel": {
                            "show": true,
                            "color": "#fff",
                            "fontSize": 14,
                            "fontWeight": 400
                        },
                        "splitLine": {
                            "show": true,
                            "lineStyle": {
                                "color": "rgba(97, 122, 190, 0.2)",
                                "type": "dashed"
                            }
                        }
                    },
                    "barSetting": {
                        "barWidth": 16,
                        "markPoint": {
                            "label": {
                                "normal": {
                                    "textStyle": {
                                        "color": "#fff",
                                        "fontSize": 14,
                                        "fontWeight": 400
                                    }
                                }
                            },
                            "itemStyle": [],
                            "data": [],
                            "symbol": "pin",
                            "symbolSize": 50
                        },
                        "label": {
                            "normal": {
                                "show": true,
                                "position": "top",
                                "fontSize": 12,
                                "color": "rgba(255, 199, 46, 1)",
                                "fontWeight": 500
                            }
                        },
                        "itemStyle": {
                            "borderRadius": [0, 0, 0, 0]
                        },
                        "markLine": {
                            "label": {
                                "color": "rgba(255, 255, 255, 0)",
                                "fontSize": 10
                            },
                            "symbol": "none",
                            "lineStyle": {
                                "type": "dashed",
                                "color": "rgba(255, 140, 25, 1)"
                            },
                            "data": [{
                                "type": "average",
                                "name": "均值"
                            }]
                        }
                    }
                },
                userSearchAxis: {
                    "xAxis": {
                        "data": ["2025-06-19","2025-06-19"] // 日期 多个,隔开
                    },
                    "series": [{
                        "name": "记录数量",
                        "data": [150], // 数量 日期多少个 数量多少个 多个,隔开
                        "type": "bar"
                    }]
                },
            };

        },
        filters: {},
        created() {
            /*if (getUrlKey('viewSource')) {
                this.viewSource = getUrlKey('viewSource');
            }*/
          this.getUserSource()
          this.getUserSearchAxis()
          this.getUserSearchWord()
          this.getUserSearchRank()
          this.getUserSearchType()
        },
        mounted() {

            let that = this;
            window.onresize = () => {
                that.screenWidth = that.$refs.antdVue.offsetWidth
                that.screenHeight = that.$refs.antdVue.offsetHeight
                that.handleResize();
            }
            this.$nextTick(() => {
                that.handleResize();
            })
        },
        computed: {

        },
        watch: {
            screenWidth(val) {
                if (!this.timerW) {
                    let that = this;
                    // that.screenWidth = val;
                    this.timerW = true;
                    that.handleResize();
                    setTimeout(function() {
                        that.timerW = false;
                    }, 400)
                }
            },
            screenHeight(val) {
                if (!this.timerH) {
                    let that = this;
                    // that.screenHeight = val;
                    this.timerH = true;
                    that.handleResize();
                    setTimeout(function() {
                        that.timerH = false;
                    }, 400)
                }
            }
        },
        methods: {
          moment,
          themeColorInit,
          isEmpty,
          //统一获取自定义接口
          get_diy_api_page() {

          },
          getUserSource() {
            userSource().then(response => {
              this.userSourcePie={"series": [{"data": response.data}] }
            })
          },
          getUserSearchType() {
            let param = {
              startTime: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
              endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            }
            userSearchType(param).then(response => {
              this.userSearchType={"series": [{"data": response.data}] }
            })
          },
          getUserSearchAxis() {
            //只查7天内的
            let param = {
              chartType: 'days',
              startTime: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
              endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            }
            userSearchAxis(param).then(response => {
              const total = response.data.total || {}
              const orderCount = total.orderCount ?? 0
              const orderUserCount = total.orderUserCount ?? 0
              this.orderCount = { data: orderCount }
              this.orderUserCount = { data: orderUserCount }
              // 人均搜索量 = orderCount / orderUserCount 保留1位小数
              const avgSearch = orderUserCount === 0 ? 0 : orderCount / orderUserCount
              this.avgSearchCount = { data: Number(avgSearch.toFixed(1)) }

              //只取xxAxis 和 orderUserCountList最后4天的数据
              const xxAxis = (response.data.xxAxis || []).slice(-5)
              const orderUserCountList = (response.data.yyAxis?.orderUserCountList || []).slice(-5)
              this.userSearchAxis = {
                xAxis: {
                  data: xxAxis
                },
                series: [{
                  name: "记录数量",
                  data: orderUserCountList,
                  type: "bar"
                }]
              }
              this.userSearchLine = {
                xAxis: {
                  data: response.data.xxAxis
                },
                series: [{
                  name: "记录数量",
                  data: response.data.yyAxis?.orderCountList || [],
                  type: "line"
                }]
              }

            })
          },
          getUserSearchWord() {
            let param = {
              startTime: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
              endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            }
            userSearchWord(param).then(response => {
              this.userSearchWord = {
                series: response.data
              }
              this.keywordCount = { data: response.data.length }
            })
          },

          getUserSearchRank() {
            let param = {
              startTime: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
              endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            }
            userSearchRank(param).then(response => {
              this.userSearchRank= {
                "yAxis": {
                  data: response.data.yyAxis.userNameList
                },
                "series": [{
                  "name": "记录数量",
                  "type": "bar",
                  "data": response.data.xxAxis
                }]
              }
            })
          },




          handleResize() {
              let that = this;
              this.$nextTick(() => {
                  that.screenWidth = that.$refs.antdVue.offsetWidth
                  that.screenHeight = that.$refs.antdVue.offsetHeight
                  let screenWidth = that.screenWidth;
                  let screenHeight = that.screenHeight;
                  let scale = Math.min(screenWidth / this.designWidth, screenHeight / this.designHeight);
                  let horizontalOffset = (screenWidth - this.designWidth * scale) / 2;
                  that.calculateStyles = {
                      transformOrigin: 'top left',
                      transform: `translateX(${horizontalOffset}px)  scale(${scale}) `,
                  };
              });
          }

        }
    }
</script>
<style lang="less" scoped>
    @import '../../assets/diypaaspc/diy-pass-big-screen.css';
    @import '../../assets/diypaaspc/library-ant-design-vue.css';

    .antdVue {
        position: relative;
        width: 100%;
        width: 1920px;
        height: 1080px;
        background: transparent;
        background-size: 100% auto !important;
    }

    .zoom_bg_color {
        background: rgba(2, 8, 15, 0);
    }

    #antdVue .sousuofenxidaping_139_random_flex_0 {
        background-position: 0px 10px;
    }

    #antdVue .sousuofenxidaping_956_fd0_1_c2_c0_c1_c1 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240227/e4aea83c3d74843a938fcf05097ac2ce.png) no-repeat;
        height: 85%;
    }

    #antdVue .sousuofenxidaping_582_fd0_1_c2_c0_c0_c1_c0_c0 {
        border-radius: 0px 0px 0px 0px;
        left: 122px;
    }

    #antdVue .sousuofenxidaping_302_fd0_1_c2_c0_c0_c1_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240424/0d3f38d193b2d84cc567a6e48e5c46d4.png) 41.5px center / 200px 200px no-repeat;
    }

    #antdVue .sousuofenxidaping_527_fd0_1_c2_c0_c0_c1 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240227/e4aea83c3d74843a938fcf05097ac2ce.png) no-repeat;
    }

    #antdVue .sousuofenxidaping_548_random_fd0_1_c1_c0_c2_c1_c0_c1 {
        height: 210px;
    }

    #antdVue .sousuofenxidaping_793_fd0_1_c1_c0_c2_c1_c0_c0 {
        width: 4px;
        height: 4px;
        border-radius: 0px 0px 0px 0px;
        top: 0px;
        left: 0px;
    }

    #antdVue .sousuofenxidaping_581_fd0_1_c1_c0_c2_c1_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240228/8cf8b692a337f016ee10717cd8d2105b.png) no-repeat;
        margin: 29px 0px 0px 0px;
    }

    #antdVue .sousuofenxidaping_486_fd0_1_c1_c0_c2_c1 {
        height: 252px;
    }

    #antdVue .sousuofenxidaping_800_fd0_1_c1_c0_c2_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240222/41e5896903526d69db3e7cbe70e4b8d7.png) no-repeat;
        height: 49px;
        max-width: 796px;
    }

    #antdVue .sousuofenxidaping_702_fd0_1_c1_c0_c2 {
        margin: -82px 0px 0px 0px;
    }

    #antdVue .sousuofenxidaping_899_random_fd0_1_c1_c0_c1_c1_c1_c0_c0 {
        line-height: 36px;
        font-size: 46px;
        font-weight: 800;
    }

    #antdVue .sousuofenxidaping_993_random_fd0_1_c1_c0_c1_c1_c0_c0_c0 {
        font-size: 48px;
        line-height: 36px;
        font-weight: 800;
    }

    #antdVue .sousuofenxidaping_307_fd0_1_c1_c0_c1_c1 {
        padding: 0px 46px 0px 46px;
    }

    #antdVue .sousuofenxidaping_291_fd0_1_c1_c0_c1_c0_c0_c0_c1 {
        font-family: Source Han Sans SC, Source Han Sans SC;
    }

    #antdVue .sousuofenxidaping_174_random_fd0_1_c1_c0_c1_c0_c0_c0_c0 {
        font-size: 48px;
        font-weight: 800;
        line-height: 36px;
    }

    #antdVue .sousuofenxidaping_350_fd0_1_c1_c0_c1_c0_c0_c0 {
        margin: 8px 0px 0px -1px;
    }

    #antdVue .sousuofenxidaping_967_fd0_1_c1_c0_c1_c0_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240228/ae5296eed3a5ba871739e3764c97ca34.png) no-repeat;
        width: 135.62px;
        height: 135.62px;
    }

    #antdVue .sousuofenxidaping_307_fd0_1_c1_c0_c1_c0 {
        padding: 0px 114px 0px 114px;
    }

    #antdVue .sousuofenxidaping_753_fd0_1_c1_c0_c1 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240228/02ea73c9a332cd5f6532378ac2a64f64.png) no-repeat;
        width: 95%;
        height: 542.52px;
    }

    #antdVue .sousuofenxidaping_519_fd0_1_c1_c0_c0_c1 {
        font-weight: 800;
        font-family: Source Han Sans SC, Source Han Sans SC;
        margin: 0px 16px 0px 16px;
    }

    #antdVue .sousuofenxidaping_349_fd0_1_c1_c0_c0_c0 {
        width: 15px;
        height: 12px;
        border-radius: 0px 0px 0px 0px;
    }

    #antdVue .sousuofenxidaping_802_fd0_1_c1_c0_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240222/41e5896903526d69db3e7cbe70e4b8d7.png) no-repeat;
        height: 49px;
        margin: 25px 0px 41px 0px;
        max-width: 796px;
    }

    #antdVue .sousuofenxidaping_646_fd0_1_c0_c0_c1 {
        height: 284px;
        margin: 21px 0px 0px 0px;
    }

    #antdVue .sousuofenxidaping_685_fd0_1_c0_c0_c0_c1 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240227/e4aea83c3d74843a938fcf05097ac2ce.png) no-repeat;
        height: 85%;
        margin: 8px 0px 0px 0px;
    }

    #antdVue .sousuofenxidaping_597_fd0_1_c0_c0_c0_c0_c0 {
        font-family: Source Han Sans SC, Source Han Sans SC;
        top: -10px;
        left: 10%;
    }

    #antdVue .sousuofenxidaping_167_fd0_1_c0_c0_c0_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/85e2307616f2c0de40317285a2bdf4f4.png) no-repeat;
        height: 28px;
    }

    #antdVue .sousuofenxidaping_787_fd0_1_c0_c0_c0 {
        height: 284px;
    }

    #antdVue .sousuofenxidaping_514_fd0_1_c0_c0 {
        margin: 15px 0px 0px 0px;
    }

    #antdVue .sousuofenxidaping_529_random_fd0_0_c5 {
        width: 70px;
        height: 70px;
        --full-screen-color: rgba(255, 255, 255, 1);
        --full-screen-width: 35px;
        --full-screen-height: 35px;
        top: 28px;
        right: 100px;
        z-index: 99;
    }

    #antdVue .sousuofenxidaping_257_random_fd0_0_c4_c1 {
        color: rgba(255, 255, 255, 1);
    }

    #antdVue .sousuofenxidaping_675_fd0_0_c4_c0 {
        width: 32px;
        height: 32px;
        border-radius: 0px 0px 0px 0px;
        margin: 0px 8px 0px 0px;
    }

    #antdVue .sousuofenxidaping_820_fd0_0_c4 {
        width: 300px;
        top: 38px;
        right: 180px;
        height: 50px;
    }

    #antdVue .sousuofenxidaping_200_fd0_0_c3 {
        width: 48px;
        height: 48px;
        border-radius: 0px 0px 0px 0px;
        margin: 0px 0px 0px 8px;
    }

    #antdVue .sousuofenxidaping_895_fd0_0_c1 {
        width: 48px;
        height: 48px;
        margin: 0px 8px 0px 0px;
    }

    #antdVue .sousuofenxidaping_653_fd0_0_c0_c3 {
        margin: 0px 0px 0px 8px;
        line-height: 10px;
    }

    #antdVue .sousuofenxidaping_174_fd0_0_c0_c2 {
        background: linear-gradient(180deg, rgba(216, 226, 255, 0) 0%, #E3EAFF 49%, rgba(216, 226, 255, 0) 100%);
        width: 2px;
        height: 16px;
        margin: 0px 0px 0px 8px;
    }

    #antdVue .sousuofenxidaping_736_fd0_0_c0_c1 {
        margin: 0px 0px 0px 8px;
    }

    #antdVue .sousuofenxidaping_572_fd0_0_c0_c0 {
        width: 32px;
        height: 32px;
        border-radius: 0px 0px 0px 0px;
    }

    #antdVue .sousuofenxidaping_205_fd0_0_c0 {
        top: 38px;
        left: 82px;
        height: 50px;
    }

    #antdVue .sousuofenxidaping_132_fd0_0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/95867b2fe8e71f9cd1cf14259ed09824.png) no-repeat;
        font-size: 48px;
        height: 135px;
        font-weight: 800;
    }

    .zoom_bg_color {
        background: url('https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240218/28580720a4073072604131817b3e36d2.png') center center / 100% 100% no-repeat !important;

    }
</style>